import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forWhom = ['Eres estudiante y el teléfono se te va "de las manos"', 'Te sirve el estilo práctico: "haz esto hoy"', 'Quieres resultados sin motivación perfecta'];
const notForWhom = ['Buscas terapia profunda o un enfoque clínico', 'No usas redes / no tienes este problema', 'Quieres un sistema "perfecto" (esto es realista)'];
export function ForWhomSection() {
  return <section className="w-full bg-gradient-to-br from-navy to-navy-light py-20 px-4 sm:px-6 lg:px-8" data-id="element-87">
      <div className="max-w-6xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-89">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-90">
            Para quién es / <span className="text-teal" data-id="element-91">para quién NO</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-92">
          {/* Es para ti si */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="bg-white rounded-xl p-8" data-id="element-93">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center" data-id="element-94">
              <div className="bg-teal/10 w-10 h-10 rounded-full flex items-center justify-center mr-3" data-id="element-95">
                <CheckIcon className="w-6 h-6 text-teal" aria-hidden="true" data-id="element-96" />
              </div>
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-97">
              {forWhom.map((item, index) => <li key={index} className="flex items-start" data-id="element-98">
                  <CheckIcon className="w-5 h-5 text-teal mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-99" />
                  <span className="text-gray-700 leading-relaxed" data-id="element-100">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="bg-white rounded-xl p-8" data-id="element-101">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center" data-id="element-102">
              <div className="bg-red-100 w-10 h-10 rounded-full flex items-center justify-center mr-3" data-id="element-103">
                <XIcon className="w-6 h-6 text-red-600" aria-hidden="true" data-id="element-104" />
              </div>
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-105">
              {notForWhom.map((item, index) => <li key={index} className="flex items-start" data-id="element-106">
                  <XIcon className="w-5 h-5 text-red-600 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-107" />
                  <span className="text-gray-700 leading-relaxed" data-id="element-108">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}